import { observer } from 'mobx-react';
import { FC, useMemo } from 'react';
import ProductExclusion from '../../components/ProductExclusion/ProductExclusion';
import { orderProductModalStore } from '../../store/orderProductModalStore';
import Text from 'src/view/components/Text/Text';

const ProductExclusions: FC = observer((): JSX.Element | null => {
  const isAvailableExclusions = useMemo((): boolean => {
    return Boolean(Array.isArray(orderProductModalStore.product?.exclusions) && orderProductModalStore.product?.exclusions.length);
  }, [orderProductModalStore.product?.exclusions]);

  if (!isAvailableExclusions || orderProductModalStore.loadingProduct) return null;

  return (
    <div className="d-flex flex-column gap-15">
      <Text type="block-header" text="Exclusions" />

      {orderProductModalStore.product?.exclusions.map((exclusion) => (
        <ProductExclusion key={exclusion.id} exclusion={exclusion} onChangeExclusions={orderProductModalStore.onChangeExclusions} />
      ))}
    </div>
  );
});

export default ProductExclusions;
